module.exports = {"locales":["cs","sk","hu"],"defaultLocale":"hu","shallowLocale":"hu"}